import type { IAnalytics, IMedia } from "./IAnalytics";
import axios, { type Axios } from "axios";

export class MegaMidiaTiagoAnalytics implements IAnalytics {
	request: Axios;

	constructor() {
		this.request = axios.create({
			baseURL: "https://api.tvtreinamento.com.br/player.php",
		});
	}

	async video(params: {
		playerId: string;
		videoId: string;
		videoName: string;
	}): Promise<boolean> {
		await this.request.post("", {
			action: "playing",
			player: {
				id: params.playerId,
			},
			id_media: params.videoId,
			nome_media: params.videoName,
			timestamp: new Date().toISOString(),
		});
		return true;
	}

	async watched(params: {
		playerId: string;
		videoId: string;
		videoName: string;
		seconds: number;
	}): Promise<boolean> {
		await this.request.post("", {
			action: "watched",
			player: {
				id: params.playerId,
			},
			id_media: params.videoId,
			nome_media: params.videoName,
			seconds: params.seconds,
			timestamp: new Date().toISOString(),
		});
		return true;
	}

	async click(playerId: string, button: string) {
		await this.request.post("", {
			action: "click",
			player: {
				id: playerId,
			},
			button,
			timestamp: new Date().toISOString(),
		});
		return true;
	}

	async ping(params: {
		playerId: string;
		uptime: number;
		state: "tocando" | "screensaver" | "parado";
		medias_total: number;
		medias_count?: number;
		medias_signature?: string;
		medias_included?: boolean;
		medias?: IMedia[];
		media?: IMedia;
		app_version?: string;
		app_shell?: string;
		app_runtime?: string | null;
		timestamp?: string;
	}) {
		await this.request.post("", {
			action: "ping",
			player: {
				id: params.playerId,
			},
			uptime: params.uptime,
			medias_total: params.medias_total,
			medias_count: params.medias_count,
			medias_signature: params.medias_signature,
			medias_included: params.medias_included,
			// Only present when the list changed: absent means "unchanged", not empty.
			...(params.medias ? { medias: params.medias } : {}),
			state: params.state,
			app_version: params.app_version,
			app_shell: params.app_shell,
			app_runtime: params.app_runtime,
			timestamp: params.timestamp,
		});

		return true;
	}
}
